import React from "react";

import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper";
import { FaNode, FaReact } from "react-icons/fa";
import { GrStripe } from "react-icons/gr";
import { BsGithub } from "react-icons/bs";
import {
  SiCss3,
  SiExpress,
  SiFirebase,
  SiReactrouter,
  SiRedux,
  SiTailwindcss,
} from "react-icons/si";
import { useLoaderData } from "react-router-dom";
import { DiMongodb } from "react-icons/di";
const ProjectDetails = () => {
  const Project = useLoaderData();
  console.log(Project);
  return (
    <div className="md:mx-8 mx-5 my-20">
      <div className="h-full bg-gray-200 mb-20 rounded-lg p-10">
        <h1 className="text-4xl font-extrabold text-center mb-3">
          {Project?.name}
        </h1>
        <p className="text-xl font-semibold">{Project.Details[0].shortDes}</p>
        <div className="flex justify-center mt-5">
          <a target="_blank" href={Project?.liveLink}>
            <button className="bg-green-600 p-3 rounded-md text-white">
              Live Site
            </button>
          </a>
        </div>
      </div>
      <h1 className="text-3xl font-semibold  sm:mx-0 p-2 md:mx-0 lg:mx-96  text-center mb-3">
        Project Screen Shoot
      </h1>
      <div className="mt-10">
        <Swiper
          direction="horizontal"
          pagination={{
            dynamicBullets: true,
          }}
          modules={[Pagination]}
          className="mySwiper"
        >
          {Project.Details[0].projectSample.map((item, index) => (
            <SwiperSlide key={index}>
              <img src={item} alt="" />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div className="mt-20">
        <h1 className="font-bold text-2xl mb-3">Project OverView</h1>
        <p>
          {Project.Details[0].projectOverview.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </p>
      </div>
      <div className="mt-20">
        <h1 className="text-2xl font-bold mb-5">Technology Used</h1>
        <div class="flex flex-wrap ">
          <div className="mx-2">
            {Project.Details[0].toolsandTech[0].tools1 === "React.js" && (
              <>
                <FaReact className="text-6xl"></FaReact>
                React.js
              </>
            )}
          </div>
          <div className="mx-2">
            {Project.Details[0].toolsandTech[0].tools2 === "Firebase" && (
              <>
                <SiFirebase className="text-6xl"></SiFirebase>
                Firebase
              </>
            )}
          </div>
          <div className="mx-2">
            {Project.Details[0].toolsandTech[0].tools3 ===
              "react-router-dom" && (
              <>
                <SiReactrouter className="text-6xl"></SiReactrouter>
                React-Router-Dom
              </>
            )}
          </div>
          <div className="mx-2">
            {Project.Details[0].toolsandTech[0].tools4 === "JWT Token" && (
              <>
                <FaNode className="text-6xl"></FaNode>
                JWT Token
              </>
            )}
          </div>
          <div className="mx-2">
            {Project.Details[0].toolsandTech[0].tools5 === "MongoDB" && (
              <>
                <DiMongodb className="text-6xl"></DiMongodb>
                MongoDB
              </>
            )}
          </div>
          <div className="mx-2">
            {Project.Details[0].toolsandTech[0].tools6 === "redux" && (
              <>
                <SiRedux className="text-6xl"></SiRedux>
                Redux
              </>
            )}
          </div>
          <div className="mx-2">
            {Project.Details[0].toolsandTech[0].tools7 === "Express.js" && (
              <>
                <SiExpress className="text-6xl"></SiExpress>
                Express.js
              </>
            )}
          </div>

          <div className="mx-2">
            {Project.Details[0].toolsandTech[0].tools8 === "Stripe" && (
              <>
                <GrStripe className="text-6xl"></GrStripe>
                Stripe
              </>
            )}
          </div>
          <div className="mx-2">
            {Project.Details[0].toolsandTech[0].tools10 === "CSS3" && (
              <>
                <SiCss3 className="text-6xl"></SiCss3> CSS3
              </>
            )}
          </div>
          <div className="mx-2">
            {Project.Details[0].toolsandTech[0].tools9 === "TailwindCSS" && (
              <>
                <SiTailwindcss className="text-6xl"></SiTailwindcss>
                TailwindCSS
              </>
            )}
          </div>

          <div className="mx-2">
            {Project.Details[0].toolsandTech[0].tools11 === "Github" && (
              <>
                <BsGithub className="text-6xl"></BsGithub>
                Github
              </>
            )}
          </div>
        </div>
        <div className="flex justify-start mt-10">
          <a target="_blank" href={Project?.serverside}>
            <button className="bg-emerald-500 rounded-md p-1 mx-2 text-white">
              Server Side Code
            </button>
          </a>
          <a target="_blank" href={Project?.clientside}>
            <button className="bg-lime-600 px-3 p-1 rounded-md text-white mx-2">
              Client Side
            </button>
          </a>
          <a target="_blank" href={Project?.liveLink}>
            <button className="bg-green-600 px-3 p-1 rounded-md text-white">
              Live Site
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ProjectDetails;
